import sumo, { createPlayerStateGetter } from '../../../utils/qos/qos-helpers'
import createQoSDataStore from '../../../utils/qos/create-qos-data-store'
import generateId from '../../../utils/generateId'

const LOGGING_INTERVAL = 300000 // every 5 mins
const userSessionId = generateId()

const ERROR_TYPES = {
  unknown: 'MEDIA_ERR_UNKNOWN',
  1: 'MEDIA_ERR_ABORTED',
  2: 'MEDIA_ERR_NETWORK',
  3: 'MEDIA_ERR_DECODE',
  4: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
  5: 'MEDIA_ERR_ENCRYPTED',
}
export default function qualityOfServiceLogging({
  videoStartTime,
  player,
  episode: {
    title,
    programme,
    guid,
  } = {},
  groupToken: userGroupToken,
}) {
  const getPlayerState = createPlayerStateGetter({ type: 'VOD', player })

  const playerInitState = getPlayerState()
  const { name: programmeName, guid: programmeGuid } = programme

  const qosDataStore = createQoSDataStore({
    defaultStateParams: {
      userGroupToken,
      userSessionId,
      episode: title || 'no episode title available',
      episodeGuid: guid || 'no episode guid available',
      programme: programmeName,
      programmeGuid,
      videoStartTime: videoStartTime && videoStartTime / 1000,
      ...playerInitState,
    },
    getPlayerState,
  })
  let logger

  // The BC SSAI plugin suppresses the `playing` event during ad playback
  // so this should fire at the start of content
  player.one('playing', () => {
    reportPlayerState(true)
  })

  player.on('play', () => {
    logger = setInterval(reportPlayerState, LOGGING_INTERVAL)
  })

  player.on('pause', () => {
    clearLoggerInterval()
  })

  player.on('error', handlePlayerError)

  player.on('ended', clearLoggerInterval)

  player.on('ads-ad-started', handleAdStarted)

  // playback event handlers
  function reportPlayerState(isCalledOnInit) {
    try {
      const qosData = qosDataStore.getQosState()
      if (isCalledOnInit) sumo.reportVideoQoS(qosData)
    } catch (e) {
      console.error('QoS: Unable to log playback state', e) // eslint-disable-line no-console
    }
  }

  function handlePlayerError() {
    try {
      const error = player.error()
      const qosState = qosDataStore.getQosState()

      sumo.reportVideoError({
        ...qosState,
        errorCode: error && error.code
          ? error.code
          : 'unknown',
        errorType: error && error.code
          ? ERROR_TYPES[error.code]
          : 'unknown',
        errorMessage: error && error.message
          ? error.message
          : 'Unknown error.',
      })

      clearLoggerInterval()
    } catch (e) {
      console.error('Qos: Unable to log playback error', e) // eslint-disable-line no-console
    }
  }

  function clearLoggerInterval() {
    clearInterval(logger)
  }

  function handleAdStarted() {
    try {
      const { ad, pod } = player.ads
      sumo.reportAdQoS({
        ...qosDataStore.getQosState(),
        adDuration: ad.duration,
        adId: ad.id,
        adIndex: ad.index,
        podId: pod.id,
        podSize: pod.size,
      })
    } catch (e) {
      console.error('QoS: Unable to log advert start', e) // eslint-disable-line no-console
    }
  }
}
